const TYPES = require('reducers/welcomeMat').ACTION_TYPES;

module.exports = {
    TYPES,
    updateWelcome: function (welcomeMat) {
        return {
            type: TYPES.UPDATE_WELCOME,
            welcomeMat: welcomeMat
        };
    }
};
